import AirConsole from '@/components/air/AirConsole'

/** /app/air-monitoring: the Air Intelligence Console, full height under the app top bar. */
export default function AirMonitoring() {
  return (
    <div className="h-[calc(100vh-4rem)] min-h-[560px]">
      <AirConsole />
    </div>
  )
}
